export default "__VITE_ASSET__DCQ3IYhJ__"